import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Interface para um destinatário de WhatsApp
 */
export interface WhatsappRecipient {
  id: string;
  name: string;
  phone: string;
  whatsAppNumber?: string;
  email: string;
  role: string;
  type: string;
  signUrl?: string; // Link de assinatura para este destinatário
}

@Component({
  selector: 'app-whatsapp-selection-dialog',
  templateUrl: './whatsapp-selection-dialog.component.html',
  styleUrls: ['./whatsapp-selection-dialog.component.sass']
})
export class WhatsappSelectionDialogComponent {
  // Destinatários selecionados
  selectedRecipients: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<WhatsappSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      recipients: WhatsappRecipient[],
      contractId: string
    }
  ) {
    // A linha abaixo foi removida para permitir fechar ao clicar fora
    // this.dialogRef.disableClose = true;
  }

  /**
   * Alterna a seleção de um destinatário
   */
  toggleRecipient(recipientId: string): void {
    const index = this.selectedRecipients.indexOf(recipientId);
    if (index === -1) {
      this.selectedRecipients.push(recipientId);
    } else {
      this.selectedRecipients.splice(index, 1);
    }
  }

  /**
   * Verifica se um destinatário está selecionado
   */
  isSelected(recipientId: string): boolean {
    return this.selectedRecipients.indexOf(recipientId) !== -1;
  }

  /**
   * Seleciona todos os destinatários
   */
  selectAll(): void {
    this.selectedRecipients = this.data.recipients.map(r => r.id);
  }

  /**
   * Limpa todas as seleções
   */
  clearAll(): void {
    this.selectedRecipients = [];
  }

  /**
   * Fecha o diálogo e retorna os IDs selecionados
   */
  confirm(): void {
    this.dialogRef.close(this.selectedRecipients);
  }
}
